import { toast } from 'react-toastify';

import { ApiResponseType } from '../types/ApiResponseTypes';

const apiUrl = process.env.NEXT_PUBLIC_API_URL;

const sendEmail = async (
  companyName: string,
  email: string,
  message: string
): Promise<ApiResponseType> => {
  let result;

  try {
    const response = await fetch(`${apiUrl}/email`, {
      method: 'POST',
      mode: 'cors',
      redirect: 'follow',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        companyName,
        email,
        message,
      }),
    });

    result = await response.json();
    if (result.errors?.length) {
      toast.error(result.errors[0].message);
    }
    return result;
  } catch (error) {
    toast.error(error);
    return result;
  }
};

export default sendEmail;
